import React from 'react';
import {
	DeliveryBrandAttribute,
	FabricsBrandAttribute,
	SewingBrandAttribute,
	TimeBrandAttribute,
} from './brand-attribute';
import { BrandAttributesSection } from './styles';

type Props = {
	openStoreSelectionModal: VoidFunction;
};

export const BrandAttributes = ({ openStoreSelectionModal }: Props) => (
	<BrandAttributesSection>
		<FabricsBrandAttribute />
		<TimeBrandAttribute />
		<SewingBrandAttribute onClick={openStoreSelectionModal} />
		<DeliveryBrandAttribute onClick={openStoreSelectionModal} />
	</BrandAttributesSection>
);
